import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "User",
  [
    [
      "path",
      {
        d: "M12.6667 4C11.0098 4 9.66669 5.34315 9.66669 7C9.66669 8.65685 11.0098 10 12.6667 10C14.3235 10 15.6667 8.65685 15.6667 7C15.6667 5.34315 14.3235 4 12.6667 4ZM7.66669 7C7.66669 4.23858 9.90526 2 12.6667 2C15.4281 2 17.6667 4.23858 17.6667 7C17.6667 9.76142 15.4281 12 12.6667 12C9.90526 12 7.66669 9.76142 7.66669 7ZM5.13115 15.4645C6.06883 14.5268 7.3406 14 8.66669 14H16.6667C17.9928 14 19.2645 14.5268 20.2022 15.4645C21.1399 16.4021 21.6667 17.6739 21.6667 19V21C21.6667 21.5523 21.219 22 20.6667 22C20.1144 22 19.6667 21.5523 19.6667 21V19C19.6667 18.2044 19.3506 17.4413 18.788 16.8787C18.2254 16.3161 17.4623 16 16.6667 16H8.66669C7.87104 16 7.10798 16.3161 6.54537 16.8787C5.98276 17.4413 5.66669 18.2044 5.66669 19V21C5.66669 21.5523 5.21897 22 4.66669 22C4.1144 22 3.66669 21.5523 3.66669 21V19C3.66669 17.6739 4.19347 16.4021 5.13115 15.4645Z",
      },
    ],
  ],
  "currentColor"
);
